import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ProductoDialogComponent } from '../productos/product-dialog/product-dialog.component';
import { SearchDialogComponent } from '../shared/search-dialog/search-dialog.component';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-mobile-root',
  templateUrl: './app-mobile.component.html',
  styleUrls: ['./app-mobile.component.scss']
})
export class AppMobileComponent implements OnInit, OnDestroy {
  isSidenavOpen = false;
  isVendedor = false;
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.authService.currentUser$.pipe(takeUntil(this.destroy$)).subscribe(user => {
      if (user?.['rol']) {
        const rolNombre = typeof user['rol'] === 'string'
          ? user['rol']
          : user['rol']?.['rol'];
        this.isVendedor = rolNombre === 'Vendedor';
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSidenav(): void {
    this.isSidenavOpen = !this.isSidenavOpen;
  }

  closeSidenav(): void {
    this.isSidenavOpen = false;
  }

  logout(): void {
    this.authService.logout();
    this.isSidenavOpen = false;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ProductoDialogComponent, {
      width: '90vw',
      maxWidth: '600px',
      data: { isEdit: false }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Lógica para guardar el nuevo producto
      }
    });
  }

  openSearchDialog(): void {
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      width: '90vw',
      maxWidth: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // El producto seleccionado está en result
        console.log('Producto seleccionado:', result);
      }
    });
  }
}

